import React from "react";
import axios from 'axios'

import { Container, Row } from "reactstrap";

import { API_CANDIDATE,API_AUTH } from "../../../utils/config";
import { Validator } from "../../../common/Validator";
import {
  updateProfilePic,
  getProfileInfo,
} from "../../../redux/action/profileInfoAction";
import UpdatePersonalDetail from "./updatePersonalDetail";
import { connect } from "react-redux";


/**
 * PersonalDetails Component for displaying the personal details information
 */
class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      file: "",
      edit:false,
      fileError: "",
      getimage: "",
      getMail:""
    };
    this.fileHandler = this.fileHandler.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this)
    this.currentMailId = this.currentMailId.bind(this)
  }

  componentDidMount() {
    this.props.getProfileInfo();
    this.currentMailId()
  }

  // file handling for photo uploading

  fileHandler(e) {
    console.log(e.target.files[0]);
    Validator(e.target);
    let allowedExtension = /(\.png|\.jpg|\.jpeg|\.gif)$/i;
    if (allowedExtension.exec(e.target.files[0].name)) {
    if ((e.target.files[0].size / 1024 / 1024).toFixed(1) < 1) {
      this.setState({
        file: e.target.files[0] || [],
        fileError: "",
      });

      let fd = new FormData();
      fd.append("userId", this.props.profile.data.userId);
      fd.append("firstName", this.props.profile.data.firstName);
      fd.append("lastName", this.props.profile.data.lastName);
      fd.append("country", this.props.profile.data.country);
      fd.append("location", this.props.profile.data.location);
      fd.append("gender", this.props.profile.data.gender);
      fd.append("phoneNo", this.props.profile.data.phoneNo);
      fd.append("candPhoto", e.target.files[0]);

      this.props.updateProfilePic(fd);
    } else {
      this.setState({
        file: e.target.files[0],
        fileError: "File size must less than 1MB",
      });
    }
    }
    else {
      this.setState({
        file: e.target.files[0],
        fileError: "File type not allowed",
      });
    }
  }
// open update form function
  openUpdateForm(){
    this.setState({
      edit:!this.state.edit
    })
    this.props.getProfileInfo();
  }
  // getting current candidate mail-id
   currentMailId(){
    axios.get(`${API_AUTH}/v1/api/auth/get-mail-id`,{withCredentials:true}).then((res)=>{
      console.log(res.data.email)
      if(res.data.ok){
        this.setState({
          getMail:res.data.data.email
        })
      }
   
  
    }).catch((err)=>{
  
    })
   }
  


  render() {
   
    return (
      <Container
        style={{ maxWidth: "60%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1 r2_personal_width"
      >

        {!this.state.edit && <div>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            paddingTop: "1rem",
          }}
        >
          <h5 style={{ fontWeight: 500, fontSize: "1.25rem" }}>
            Personal Details
          </h5>
        </div>
        <div style={{width:"40%"}}>
                <i
                  style={{
                    marginRight: "80px",
                  
                    color: "green",
                  }}
                  className="material-icons pointer contact-edit-btn"
                  onClick={this.openUpdateForm}
                >
                  edit
                </i>
              </div>

        <i
          className="material-icons pointer cancel-button"
          onClick={this.props.back}
        >
          cancel
        </i>

        <div style={{ width: "100%", display: "flex" }}>
          <div className="personal-details-div">
            <Row>
              <ul>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">
                    Candidate ID
                    </div>
                    <div className="details-flex-div-two">:</div>
                    <div
                      
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.id}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">
                      First Name
                    </div>
                    <div className="details-flex-div-two">:</div>
                    <div
                      
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.firstName}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">
                      Last Name 
                    </div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.lastName}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Email Id</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                      
                      className="details-flex-div-three"
                    >
                     {this.state.getMail}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Country</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.country}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">
                      Location
                    </div>
                    <div className="details-flex-div-two">:</div>
                    <div
                      
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.location}
                    </div>
                  </div>
                </li>

                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Gender</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.gender}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">
                      Phone Number
                    </div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {`+${this.props.profile.data.dialingCode} ${this.props.profile.data.mobileNo}`}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Id Proof Name</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                     {this.props.profile.data.govtIdProofName}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Id Proof No.</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.govtIdProofNos}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="details-flex-main-div">
                    <div className="personal-details-flex-div-one">Years of Experience</div>
                    <div className="details-flex-div-two">:</div>
                    <div
                     
                      className="details-flex-div-three"
                    >
                      {this.props.profile.data.yearOfExp}
                    </div>
                  </div>
                </li>
           
              </ul>
            </Row>
          </div>

          <div className="personal-details-div-two">
            <div
              className="user-profile-pic-div"
              style={{
                background: `url(${API_CANDIDATE}/all/${this.props.profile.data.candPhoto})`,
              }}
            >
              <input
                type="file"
                name="userPhoto"
                className="file_upload pointer"
                accept=".png"
                onChange={this.fileHandler}
              />
            </div>

            <div
              style={{ marginLeft: "2.2rem", marginTop: "1.5rem" }}
              className="user-profile-pic-icon-div"
            >
              <i className="material-icons pointer">camera_alt</i>
              <input
                type="file"
                name="userPhoto"
                className="file_upload pointer"
                accept=".png"
                onClick={this.fileHandler}
              />
              
            </div>
            <span style={{color:"red",fontSize:"14px"}}>{this.state.fileError}</span>
          </div>
        
        </div>
        </div>}

        {
          this.state.edit && < UpdatePersonalDetail back={this.openUpdateForm}  getMail={this.state.getMail} updateData={this.props.profile.data} isOpen ={this.openUpdateForm} />
        }
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, { updateProfilePic, getProfileInfo })(
  PersonalDetails
);
